import React from 'react';

import PropTypes from 'prop-types';
import { Tooltip } from 'antd';
import classNames from 'classnames';

import { ChildrenSchema } from 'packages/utils';

import styles from './styles.module.less';

const Title = ({ value = null, className = '' }) => {
  return (
    value && (
      <div className={className}>
        <span className="gx-fs-2xl gx-font-weight-medium">{value}</span>
      </div>
    )
  );
};

Title.LabelForm = ({ value, className, required = false }) =>
  value && (
    <div className={className}>
      <span className={classNames('gx-guarnic-label', required && styles.isRequired)}>{value}</span>
    </div>
  );

Title.Header = ({ value, className }) =>
  value && (
    <div className={classNames(className, styles.header)}>
      {typeof value === 'string' ? (
        <Tooltip
          title={value}
          placement="topLeft"
          // Drawers in this app use z-index >= 1100; default Tooltip (~1030) renders underneath.
          zIndex={1300}
          mouseEnterDelay={0.1}
        >
          <span className={classNames('gx-guarnic-header', styles.headerText)}>{value}</span>
        </Tooltip>
      ) : (
        <span className="gx-guarnic-header gx-w-100">{value}</span>
      )}
    </div>
  );

Title.Filter = ({ value, className, required = false }) =>
  value && (
    <div className={className}>
      <span className={classNames('gx-guarnic-title-filter', required && styles.isRequired)}>
        {value}
      </span>
    </div>
  );

Title.SubTitle = ({ value, className }) =>
  value && (
    <div className={className}>
      <span className="gx-guarnic-headline-2">{value}</span>
    </div>
  );

Title.Description = ({ value, className }) =>
  value && (
    <div className={className}>
      <span className={styles.description}>{value}</span>
    </div>
  );

Title.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, ChildrenSchema]).isRequired,
  className: PropTypes.any,
};

export default Title;
